import { linkGoogleAuthMethod } from '../../login/google/switch-gp-on-google';
import { linkFbAuthMethod } from '../../login/fb';
import { loadAccountWindow } from '../../account-window/account-window-loader';
import {AccountView} from "../../account-window/account-view";

type StartGuestAccountLinkingRequest = {
    linkingMethod: LinkingMethod,
    isBigReward: boolean
};

enum LinkingMethod {
    EMAIL = 'email',
    FB = 'fb',
    GOOGLE = 'google'
}

export class StartAccountLinkingReward {
    public async handle(_data: StartGuestAccountLinkingRequest) {
        console.log(_data);
        switch (_data.linkingMethod) {
            case LinkingMethod.EMAIL:
                this.handleEmailLinking(_data.isBigReward);
                break;
            case LinkingMethod.FB:
                this.handleFbLinking(_data.isBigReward);
                break;
            case LinkingMethod.GOOGLE:
                this.handleGoogleLinking(_data.isBigReward);
                break;
            default:
                throw new Error('Unknown linking method');
        }
    }

    private async handleEmailLinking(isBigReward: boolean) {
        await loadAccountWindow();
        AccountView.setIsBigReward(isBigReward);
    }

    private async handleFbLinking(isBigReward: boolean) {
        await linkFbAuthMethod(isBigReward);
    }

    private async handleGoogleLinking(isBigReward: boolean) {
        await linkGoogleAuthMethod(isBigReward);
    }
}
